import { Nullable } from '@/types';

type ObjectLike<T> = T extends object ? T : never;

export function isObject<TValue>(
  value: Nullable<TValue>,
): value is ObjectLike<TValue> {
  return typeof value === 'object' && !Array.isArray(value);
}
